import { Button, ButtonColors } from '@chiroup/components/Button';
import { OpenClosedStates } from '@chiroup/components/states';
import React, { useState } from 'react';
import UserCreateModal from './UserCreateModal';

type Props = {
  onCreate: () => void;
};

const UserCreate: React.FC<Props> = ({ onCreate }) => {
  const [state, setState] = useState<OpenClosedStates>(OpenClosedStates.Closed);

  const open = () => {
    setState(OpenClosedStates.Open);
  };

  const close = () => {
    setState(OpenClosedStates.Closed);
  };

  return (
    <>
      <UserCreateModal
        state={state}
        close={close}
        onCreate={onCreate}
        // lastName={lastName}
      />
      <Button
        text="Add"
        color={ButtonColors.plainWithBorder}
        className="cursor-pointer"
        onClick={open}
      />
    </>
  );
};

export default UserCreate;
